// ========================================================================================
/*
  disabled,               [bool]
  practitioners,          [array]
  practitionerId,         [string]
  onChange                [func]
 */
// ========================================================================================


import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

// Components
import { SelectField } from 'components/Fields';
import PractitionerBlock from 'src/components/PractitionerBlock/PractitionerBlock';


const PractitionerWrapper = styled.div`
  .select-field{
    margin-bottom: 0;
  }
`;

const addNameToPractitionerList = (practitionersList, i18n) =>
  Array.isArray(practitionersList) &&
  practitionersList.map(el => {
    const translate = el.localizations && el.localizations.find(e => e.lang === i18n.language);
    el.name = translate && translate.name;
    return el;
  });

const ListItem = ({ item }) => (<PractitionerBlock practitioner={item} />);
const ValueItem = ({ item }) => (<PractitionerBlock practitioner={item} />);


const PractitionersSelect = props => {
  const { practitioners, practitionerId, i18n, ...inputProps } = props;
  const practitionersWithName = addNameToPractitionerList(practitioners, i18n);

  return practitionersWithName ? (
    <PractitionerWrapper className="practitioner-select-wrapper">
      <SelectField
        className="select-field practitioner-select"
        filter="contains"
        data={practitionersWithName}
        input={inputProps}
        value={
          practitionersWithName.find(item => item.id === practitionerId) || practitionersWithName[0]
        }
        textField="name"
        valueField="id"
        valueComponent={ValueItem}
        itemComponent={ListItem}
        messages={{
          emptyFilter: i18n.t('no_result_found_placeholder'),
          filterPlaceholder: i18n.t('search_practitioner_placeholder')
        }}
      />
    </PractitionerWrapper>
  ) : null;
};

export default translate()(PractitionersSelect);
